<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor">Onbekende documenten ({{ count }})</h3>
            </b-col>
            <b-col md="6" class="my-1">
                <div class="pull-right">
                    <b-button v-b-tooltip.hover title="Documenten met minder dan 500 karakters worden op onverwerkbaar gezet" v-on:click="documentLess500Characters" class="mx-2"><i class="fas fa-align-left"></i> 500 karakters</b-button>
                    <b-button v-b-tooltip.hover title="Opnieuw door regexprocess" v-on:click="retryDocumentsThroughOcr" class="mx-2"><i class="fas fa-share-square"></i> Regexproces</b-button>
                    <b-button v-b-tooltip.hover title="Verversen" class="mx-2"  v-on:click="refreshTable"><i class="fas fa-sync-alt"></i></b-button>
                    <b-button v-b-tooltip.hover title="Documenten op onverwerkbaar zetten" v-on:click="documentenOnverwerkbaar" class="mx-2">Onverwerkbaar</b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <!-- User Interface controls -->
                        <b-row>
                            <b-col md="12" class="my-1">
                                <b-form-group class="mb-0">
                                    <b-input-group>
                                        <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- User Interface controls -->
                        <!-- Main table element -->
                        <b-row>
                            <b-col md="12">
                                <p>
                                    <b-button size="sm" @click="selectAllRows">{{ $t('datatables.selecteerAlles') }}</b-button>
                                    <b-button size="sm" @click="clearSelected">{{ $t('datatables.deselecteerAlles') }}</b-button>
                                    <b-button v-if="!isMobile" class="ml-3" size="sm" @click="showThumbnails">{{ $t('datatables.toonthumbnails') }}</b-button>
                                    <b-button  v-if="!isMobile" size="sm" @click="hideThumbnails">{{ $t('datatables.verbergthumbnails') }}</b-button>
                                    <b-form-checkbox id="checkboxThumbnail"  style="display:inline" v-if="!isMobile" v-model="checkedThumbnailModal">{{ $t('datatables.checkboxThumbnails') }}</b-form-checkbox>
                                </p>                            
                                <b-table v-if="showTable"
                                         class="table-hover"
                                         show-empty
                                         :items="documenten" 
                                         :empty-text='getEmptyText(count)'
                                         :fields="fields"
                                         :sort-by.sync="sortBy"
                                         :sort-desc.sync="sortDesc"
                                         :current-page="currentPage" 
                                         :per-page="perPage" 
                                         :filter="filter"
                                         :tbody-tr-class="setTbodyTrClass"
                                         @row-clicked="onRowClicked"
                                         ref="documenttable"
                                         :busy="count == -1">                                                               
                                         <template v-slot:table-busy>
                                            <PreLoader/>
                                         </template>
                                         <template  v-slot:cell(selected)="row">
                                            <b-form-checkbox v-model="itemsData.find((elem) => elem.documentId == row.item.documentId).check" @input="onSelectedClicked($event, row.item)"></b-form-checkbox>
                                         </template>
                                         <template v-slot:cell(image)="data">
                                            <img v-show=" isVisibleThumbnails && !showImageLarge" :src="'data:image/jpeg;base64,'+ (data.item.image != undefined ? data.item.image : notfoundImage)" class="cell-image" />
                                            <img v-show=" isVisibleThumbnails && showImageLarge && !checkedThumbnailModal" :src="'data:image/jpeg;base64,'+ (data.item.image != undefined ? data.item.image : notfoundImage)" class="cell-image-large" />
                                            <span @mouseover="showLargeThumbnail(data.item.image)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1.25 17c0 .69-.559 1.25-1.25 1.25-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25zm1.393-9.998c-.608-.616-1.515-.955-2.551-.955-2.18 0-3.59 1.55-3.59 3.95h2.011c0-1.486.829-2.013 1.538-2.013.634 0 1.307.421 1.364 1.226.062.847-.39 1.277-.962 1.821-1.412 1.343-1.438 1.993-1.432 3.468h2.005c-.013-.664.03-1.203.935-2.178.677-.73 1.519-1.638 1.536-3.022.011-.924-.284-1.719-.854-2.297z"/></svg>
                                            </span>
                                        </template>
                                         <template v-slot:cell(fileCreationTime)="data">{{ data.item.fileCreationTime | datetime }}</template>
                                         <template v-slot:cell(amountChars)="row">{{ row.item.pdfcontent == null ? (row.item.filecontent != null ? row.item.filecontent.length : 0) : row.item.pdfcontent.length}}</template>
                                         <template v-slot:cell(actions)="row"><delete title="Document"  :noRedirect="true" :hideText="true" :id="row.item.id" namespace="fmmodule" resource="documenten" :disabled="row.item.isEdited == '1'" @onDeleted="onDocumentDeleted()" v-b-tooltip.hover/> </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
    
                        <!-- Pagination controls -->
                        <b-row>
                            <b-col md="12" lg="5">
                                <b-form-group label-cols :label="$t('datatables.perpagina')">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-form-group>
                            </b-col>
                            <b-col md="12" lg="7">
                                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                            </b-col>
                        </b-row>
                        <!-- Pagination controls -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-modal id="modalThumbnail" ref="thumbnail" :title="`Afbeelding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form autocomplete="off">
                <img :src="'data:image/jpeg;base64,'+ (currentImage != undefined ? currentImage : notfoundImage)" class="cell-image-extralarge" />
            </b-form>
        </b-modal>      
    </div>
    </template>
    <script>
    //Import store
    import { mapGetters, mapActions } from 'vuex'
    import PreLoader from '@/components/root/Preloader';
    import { getEmptyText } from '@/views/root/GetMessageTextHelper';
    
    export default {
        name: `document-index`,
        components: {PreLoader},
        data() {
            return {
                command: {},
                currentPage: 1,
                perPage: 50,
                pageOptions: [50, 100, 200],
                filter: '',
                count: -1,
                sortDesc: false,
                sortBy: "fileCreationTime",
                showTable: true,
                isVisibleThumbnails: false,
                notfoundImage: undefined,
                showImageLarge: false,
                currentImage: undefined,
                selected: [],
                isMobile: false,
                checkedThumbnailModal: false,
                itemsData: []
            }
        },
        computed: {
            fields() { 
                if (this.isVisibleThumbnails) {
                    return [
                        {
                            key: 'selected',
                            label: ''
                        },
                        {
                            key: 'image',
                            label: 'Image',
                            sortable: false
                        },                
                        {
                            key: 'documentId',
                            label: 'DocumentId',
                            sortable: true
                        },
                        {
                            key: 'klant.customerIdAndName',
                            label: 'Klant',
                            sortable: true
                        },
                        {
                            key: 'administratie.bedrijfsnaam',
                            label: 'Administratie',
                            sortable: true
                        },
                        {
                            key: 'fileCreationTime',
                            label: 'Datum',
                            sortable: true
                        },
                        {
                            key: 'amountOfCharacters',
                            label: 'Aantal karakters',
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: this.$i18n.t('datatables.acties')
                        }
                    ]
                }
                else {
                    return [
                        {
                            key: 'selected',
                            label: ''
                        },                
                        {
                            key: 'documentId',
                            label: 'DocumentId',
                            sortable: true
                        },
                        {
                            key: 'klant.customerIdAndName',
                            label: 'Klant',
                            sortable: true
                        },
                        {
                            key: 'administratie.bedrijfsnaam',
                            label: 'Administratie',
                            sortable: true
                        },
                        {
                            key: 'fileCreationTime',
                            label: 'Datum',
                            sortable: true
                        },
                        {
                            key: 'amountOfCharacters',
                            label: 'Aantal karakters',
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: this.$i18n.t('datatables.acties')
                        }
                    ]                
                }
            },
            ...mapGetters('fmmodule', ['documenten']),
        },
        methods: {
            ...mapActions('fmmodule', ['all','executeCommand', 'getImage']),
            selectAllRows() {
                this.showTable = false
                this.selected = []
                this.$refs.documenttable.selectAllRows()
                this.$refs.documenttable.items.forEach((item) => {
                    item.check = true
                    this.selected.push(item.documentId);
                })
                this.itemsData.forEach((item) => {
                    item.check = true
                })

                this.showTable = true
                this.$nextTick()
            },
            clearSelected() {
                this.showTable = false
                this.selected = []
                this.$refs.documenttable.clearSelected()
                this.$refs.documenttable.items.forEach((item) => {
                    item.check = false
                })
                this.itemsData.forEach((item) => {
                    item.check = false
                })
                this.showTable = true
                this.$nextTick();
            },   
            showThumbnails() {
                this.showTable = false
                this.$refs.documenttable.items.forEach(async (item) => {
                    this.$store.dispatch('errors/clearErrors');
                    await this.getImage(
                        {
                            resource:"images",
                            filename: item.filename
                        })
                        .then((imageData) => {
                            this.showTable = false
                            item.isImageLoaded = true
                            item.image = imageData;             
                            this.showTable = true;
                        })
                    })
    
                this.isVisibleThumbnails = true
                this.$nextTick();
            },
            hideThumbnails() {
                this.isVisibleThumbnails = false
                this.$nextTick();
            },   
            showLargeThumbnail(image) {
                this.currentImage = image
                this.showImageLarge=!this.showImageLarge
                if (this.showImageLarge && this.checkedThumbnailModal) {
                    this.showImageLarge = !this.showImageLarge
                    this.$bvModal.show("modalThumbnail")
                }
            },            
            onRowClicked(item) 
            {
                this.$router.push({ name: `documents:detail`, params: { documentId: item.id } });
            },   
            executeWithSweetAlert(text, resource, request){
            var vm = this;
                vm.$swal ({
                    title: `Actie uitvoeren`,
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: `Ja, uitvoeren`,
                    cancelButtonText: this.$i18n.t('delete.neeannuleren')
                })
                .then((result) => {
                    if (result.value) {
                        vm.executeCommand({resource: resource + request,})
                        .then((data) => {
                            this.refreshTable();                   
                            vm.$swal("Er zijn " + data.nrOfDocuments + " documenten verwerkt");
                        })
                        .catch(() => {
                            vm.$swal("Er is iets verkeerd gegaan, probeer het opnieuw");
                        });
                        this.selected = [];
                    }
                })
            },
            documentLess500Characters()
            {
                this.executeWithSweetAlert(
                    `Weet u zeker dat u alle documenten met minder dan 500 karakters op onverwerkbaar gezet worden ?`,
                    'documenten/documentLess500Characters');
            },
            retryDocumentsThroughOcr()
            {
                var messagetext = this.selected.length == 0 ? 'alle documenten' : 'de geselecteerde documenten';
                var request = this.selected.length == 0 ? '' : '?documentIds=' + this.selected
                this.executeWithSweetAlert(
                    `Weet u zeker dat u ` + messagetext + ` weer door het triggerproces wil halen ?`,
                    'documenten/retryDocumentsThroughOcr',request);          
            },
            documentenOnverwerkbaar()
            {
                if(this.selected.length != 0){
                    this.executeWithSweetAlert(
                    `Weet u zeker dat u de geselecteerde documenten op onverwerkbaar wil zetten ?`,
                    'documenten/setDocumentsToOnverwerkbaar?documentIds=' + this.selected,'');  
                }
            },                     
            refreshTable(){
                this.all({
                    resource: 'documenten',
                    subpath: '/onbekend'
                })
                .then((data) => {
                    this.count = data.result.length;
                });            
            },
            getEmptyText,
            onFiltered (filteredItems) {
                this.count = filteredItems.length;
                this.currentPage = 1
            },
            setTbodyTrClass(item) {
                var classes = '';
                if (item != null && !item.isEdited) { classes += 'is-not-edited ' }
                if (item != null && item.isOlderThenTwoWorkDays) { classes += 'two-workdays ' }
                return classes;
            },
            getFilterQuery: function(filter) {
                var query = '1 eq 1';
    
                if(filter !== '' && filter != null){
                    query += ` and (contains(tolower(klant/naam), '${filter}') or contains(tolower(administratie/bedrijfsnaam), '${filter}')`
                    query += `)`
                }
                return query;
            },
            getOrderByQuery: function(sortBy, sortDesc) {
                if(!sortBy && !sortDesc) return null;
                var sortDirection = sortDesc ? 'desc' : 'asc';
                return `${sortBy.replace('.','/')} ${sortDirection}`;
            },
            onSelectedClicked (value, item) 
            {         
                if(value){
                    if(!this.selected.includes(item.documentId)){
                        this.selected.push(item.documentId);
                    }
                }
                else{
                    var indexOfDocument = this.selected.indexOf(item.documentId)
                    if (indexOfDocument > -1)
                    {
                        this.selected.splice(indexOfDocument,1);
                    }
                }                  
            },
            onDocumentDeleted() {
                var vm = this
                vm.count = vm.count - 1
            },
            onResize () {
                this.isMobile = window.innerWidth < 600
            }
        },
        created() {
            let vm = this;
            vm.all({
                resource: 'documenten',
                subpath: '/onbekend'
            })
            .then((data) => {
                vm.count = data.result.length;
                data.result.forEach((item) => {
                    vm.itemsData.push({ 
                        documentId: item.documentId,
                        check: false
                    });
                })
            });
    
            this.getImage(
            {
                resource:"images",
                filename: "notfound.png"
            })
            .then((imageData) => {
                vm.notfoundImage = imageData;
            })
            
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        }    
    }
    
    </script>
    <style scoped>
    .is-not-edited {
        font-weight: bold;
    }
    .two-workdays {
        background: #ffeddd;
    }
    .cell-image {
        width: 50px;
        height: 70px;
    }
    .cell-image-large {
        width: 100px;
        height: 140px;
    }
    .cell-image-extralarge {
        width: 400px;
        height: 560px;
    }
    .custom-checkbox.b-custom-control-sm, .input-group-sm .custom-checkbox {
        padding-left: 2.0rem;
    }
    [type="checkbox"] + label {
        padding-left: 12px !important;
        font-size: 12px;
    }
    </style>
    